import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://locationoran.com';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
  robots?: string;
}

export function SEO({
  title = 'LocationOran.com - Location de Vacances à Oran',
  description = 'Trouvez et réservez les meilleures locations de vacances à Oran : appartements, villas, voitures, scooters et activités. Réservation en ligne simple et sécurisée.',
  keywords = 'location vacances oran, appartement oran, villa oran, location voiture oran, scooter oran, activités oran, hébergement oran, algérie tourisme',
  ogImage = 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg',
  ogType = 'website',
  canonical,
  robots = 'index, follow',
}: SEOProps) {
  const location = useLocation();
  const fullTitle = title.includes('LocationOran') ? title : `${title} | LocationOran.com`;
  const canonicalUrl = canonical || `${SITE_URL}${location.pathname}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="LocationOran.com" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <link rel="canonical" href={canonicalUrl} />

      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />

      <meta httpEquiv="Content-Language" content="fr" />
      <meta name="language" content="French" />
    </Helmet>
  );
}
